import { render, staticRenderFns } from "./NavigationSettings.vue?vue&type=template&id=6fc10fbf&scoped=true&"
import script from "./NavigationSettings.vue?vue&type=script&lang=js&"
export * from "./NavigationSettings.vue?vue&type=script&lang=js&"
import style0 from "./NavigationSettings.vue?vue&type=style&index=0&id=6fc10fbf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc10fbf",
  null
  
)

export default component.exports